// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"708":"b0435d2a","837":"1a66e364","849":"d8e7b351","936":"42807837","947":"11024c49","980":"668f7f24"}[chunkId] + ".css";
};